import Vue from 'vue';
import { router } from '@/router';
import uniqid from 'uniqid';
import * as enums from '@/types/enums';

export const mockDbName = process.env.VUE_APP_MOCK_DB_NAME;
console.log("Mock Db Name: " + mockDbName);

export default {
  /** Main Module */
  mainModuleDecorator: (module: any): void => {
    module.mutations.loadMockData = (state, payload) => {
      let mockData = require(`../../../database/${mockDbName}/collections/consenz.json`);
      let consenzPath = `../../../database/${mockDbName}/collections/consenz.json`;
      console.log('Loaded Consenz from ' + consenzPath + ": ", mockData);
      mockData = mockData.filter(d => d.id === payload)[0];
      Vue.set(state, 'data', mockData);
    };
    module.actions.initStore = async ({ state, dispatch, commit, rootGetters }) => {
      console.log('Init Store With Moch Data');
      dispatch('initStoreWithMochData');
    };
    module.actions.initStoreWithMochData = async ({state, commit}) => {
      commit('documentsModule/setPrettyLink', state.prettyLink, { root: true });

      commit('loadMockData', 'v1' );
      commit('documentsModule/loadMockData', state.prettyLink, { root: true } );
      commit('sectionsModule/loadMockData', state.prettyLink, { root: true } );
      commit('argumentsModule/loadMockData', state.prettyLink, { root: true } );
      commit('commentsModule/loadMockData', state.prettyLink, { root: true } );
      commit('changeEventsModule/loadMockData', state.prettyLink, { root: true } );
      commit('usersModule/loadMockData', state.prettyLink, { root: true } );

      commit('setLoading', false);
      const payload = { currentRoute: router.currentRoute };
      console.log('mainModule.ts Commit setToState ', payload);
      commit('routerModule/setToState', payload, { root: true });
    };
  },

  /** Users Module */
  usersModuleDecorator: (module: any): void => {
    module.mutations.loadMockData = (state, payload) => {
      let mockData = require(`../../../database/${mockDbName}/collections/users.json`);
      let usersPath = `../../../database/${mockDbName}/collections/users.json`;
      console.log('Loaded Users from ' + usersPath + ": ", mockData);
      const dataObject = {};
      mockData = mockData.filter(user => user.documents.includes(payload))
      .forEach(d => Object.assign(dataObject, { [d.id]: d }));
      Vue.set(state, "data", dataObject);
    };

    module.actions.insert = ({state}, newComment) => {
      let commentId = uniqid();
      newComment = {...newComment, id: commentId};
      Vue.set(state.data, commentId, newComment);
      return commentId;
    };
    module.actions.patch = ({ state }, { id, updateObject }) => {
      console.log("patch: state.data[" + id + "]: " + JSON.stringify(state.data[id]) +
          ", updateObject: " + JSON.stringify(updateObject));
      let updatedUser = state.data[id];
      Object.keys(updateObject).forEach(key => {
        updatedUser = Object.assign(updatedUser, {
          [key]: updateObject[key]
        });
      });
      console.log("Vue set state.data " + id + " to ", JSON.stringify(updatedUser));
      Vue.set(state.data, id, updatedUser);
      console.log("New state.data[" + id + "]: " + JSON.stringify(state.data[id]));
    }
  },

  /** Documents Module */
  documentsModuleDecorator: (module: any): void => {
    module.state.data = {};

    module.mutations.loadMockData = (state, payload) => {
      let mockData = require(`../../../database/${mockDbName}/collections/documents.json`);
      let documentsPath = `../../../database/${mockDbName}/collections/documents.json`;
      console.log('Loaded Documents from ' + documentsPath + ": ", mockData);
      mockData = mockData.filter(d => d.id === payload)[0];
      Vue.set(state.data, state.prettyLink, mockData);
    }

    module.actions.patch = ({state}, { id, pros, cons }) => {
      console.log('id, pros, cons: ', id, pros, cons)
      let updatedDocument = state.data[id];
      Object.assign(updatedDocument, { pros, cons })
      console.log("Vue set state.data " + id + " to ", JSON.stringify(updatedDocument));
      Vue.set(state.data, id, updatedDocument);
      console.log("New state.data[" + id + "]: " + JSON.stringify(state.data[id]));
    };
  },

  /** Sections Module */
  sectionsModuleDecorator: (module: any): void => {
    module.mutations.loadMockData = (state, payload) => {
      let mockData = require(`../../../database/${mockDbName}/collections/sections.json`);
      let sectionsPath = `../../../database/${mockDbName}/collections/sections.json`;
      console.log('Loaded Sections from ' + sectionsPath + ": ", mockData);
      const dataObject = {};
      const newArray = mockData
        .filter(d => d.documentId === payload)
        .map(d =>
          Object.assign(
            { ...d },
            {
              createdAt: new Date(d.createdAt),
              acceptedAt: d.acceptedAt ? new Date(d.acceptedAt) : null,
              deadline: new Date(d.deadline)
            }
          )
        )
        .forEach(d => Object.assign(dataObject, { [d.id]: d }));
      Vue.set(state, "data", dataObject);
    };

    /**
     * gets the size of the sections in a specific status
     * @param {number} status
     */
    module.actions.getSizeByStatus = async ({ state }, status) => {
    // process.env.NODE_ENV === "development"
      return Object.keys(state.data).filter(
        key => state.data[key].status === status
      ).length;
    };

    module.actions.insert = ({ state }, newSection) => {
      let newSectionId = uniqid();
      newSection = { ...newSection, id: newSectionId };
      Vue.set(state.data, newSectionId, newSection);
      return newSectionId;
    };

    module.actions.patch = ({ state }, { id, updateObject }) => {
      console.log("patch: state.data[" + id + "]: " + JSON.stringify(state.data[id]) +
        ", updateObject: " + JSON.stringify(updateObject));
      let updatedSection = state.data[id];
      Object.keys(updateObject).forEach(key => {
        updatedSection = Object.assign(updatedSection, {
          [key]: updateObject[key]
        });
      });
      console.log("Vue set state.data " + id + " to ", JSON.stringify(updatedSection));
      Vue.set(state.data, id, updatedSection);
      console.log("New state.data[" + id + "]: " + JSON.stringify(state.data[id]));
    }
  },

  /** Arguments Module */
  argumentsModuleDecorator: (module: any): void => {
    module.mutations.loadMockData = (state, payload) => {
      /*
      const argumentsMockPath = `../../../database/${mockDbName}/collections/arguments.json`;
      console.log("Arguments Mock Path: " + argumentsMockPath);
      let mockData = require(argumentsMockPath);
              This causes the following error:
      Uncaught (in promise) Error: Cannot find module '../../../database/master/collections/arguments.json'
      at webpackEmptyContext (eval at ./src/decorators/storeDecorators/moduleDecorators sync recursive (app.js:12577), <anonymous>:2:10)
      at Store.module.mutations.loadMockData (mockdataModuleDecorators.ts?4d9a:129)
      ... */
      //console.log("Arguments Mock Path: " + `../../../database/${mockDbName}/collections/arguments.json`);
      let mockData = require(`../../../database/${mockDbName}/collections/arguments.json`);
      let argumentsPath = `../../../database/${mockDbName}/collections/arguments.json`;
      console.log('Loaded Arguments from ' + argumentsPath + ": ", mockData);
      const dataObject = {};
      mockData = mockData
        .filter(d => d.documentId === payload)
        .map(d =>
          Object.assign(
            { ...d },
            {
              createdAt: new Date(d.createdAt)
            }
          )
        )
        .forEach(d => Object.assign(dataObject, { [d.id]: d }));
      Vue.set(state, "data", dataObject);
    };
    module.actions.insert = ({state}, newArgument) => {
      const argId = uniqid();
      newArgument = {...newArgument, id: argId};
      Vue.set(state.data, argId, newArgument);
      return argId;
    };
    module.actions.patch = ({state}, { id, updateObject }) => {
      console.log("updateArgument", updateObject, state.data[id]);
      let updatedArgument = state.data[id];
      Object.keys(updateObject).forEach((key) => {
        updatedArgument = Object.assign(state.data[id], {
          [key]: updateObject[key]
        })
      });
      console.log("updatedSection:", updatedArgument);
      // @ts-ignore
      Vue.set(
        state,
        "data",
        state.data.filter(element => element.id !== id).concat(updatedArgument)
        //  [...state.data.filter(element => element.id !== id), updatedArgument]
      )
    };

    /**
     * adds user the convinced array of the argument
     * @param {string} id argument id
     */
    module.actions.userConvinced = async ({ dispatch, rootGetters, state }, id) => {
      const ownerUid = rootGetters["usersModule/userUid"];
      // process.env.NODE_ENV === "development"
      const datum = state.data[id];
      const convinced = datum.convinced;
      console.log('userConvinced State ' + id + ' convinced: ' + JSON.stringify(convinced));
      let size = convinced.push(ownerUid);
      console.log('Convinced after push: ' + JSON.stringify(convinced));
      return size;
    };
    /**
     * deleted user the convinced array of the argument
     * @param {string} id argument id
     */
    module.actions.userUnconvinced = async ({ dispatch, rootGetters, state }, id) => {
      const ownerUid = rootGetters["usersModule/userUid"];
      const datum = state.data[id];
      console.log('userUnconvinced State ' + id + ' convinced: ' + JSON.stringify(datum.convinced));
      const filtered = datum.convinced.filter(function (uid) {
        return uid !== ownerUid;
      });
      console.log('Filtered: ' + JSON.stringify(filtered));
      // process.env.NODE_ENV === "development"
      const ans = Vue.set(datum, "convinced", filtered);
      console.log('Convinced after Vue set to filtered: ' + JSON.stringify(datum.convinced));
      return ans;
    };
  },

  /** Comments Module */
  commentsModuleDecorator: (module: any): void => {
    module.mutations.loadMockData = (state, payload) => {
      let mockData = require(`../../../database/${mockDbName}/collections/comments.json`);
      let commentsPath = `../../../database/${mockDbName}/collections/comments.json`;
      console.log('Loaded Comments from ' + commentsPath + ": ", mockData);
      const dataObject = {};
      mockData = mockData
        .filter(d => d.documentId === payload)
        .map(d =>
          Object.assign(
            { ...d },
            {
              createdAt: new Date(d.createdAt)
            }
          )
        )
        .forEach(d => Object.assign(dataObject, { [d.id]: d }));
      Vue.set(state, "data", dataObject);
    };
    module.actions.insert = ({state}, newComment) => {
      let commentId = uniqid();
      newComment = {...newComment, id: commentId};
      Vue.set(state.data, commentId, newComment);
      return commentId;
    }
  },

  /** ChangeEvents Module */
  changeEventsModuleDecorator: (module: any): void => {
    module.mutations.loadMockData = (state, payload) => {
      let mockData = require(`../../../database/${mockDbName}/collections/changeEvents.json`);
      let changeEventsPath = `../../../database/${mockDbName}/collections/changeEvents.json`;
      console.log('Loaded ChangeEvents from ' + changeEventsPath + ": ", mockData);
      const dataObject = {};
      mockData = mockData
          .filter(d => d.documentId === payload)
          .map(d =>
              Object.assign(
                  { ...d },
                  {
                    createdAt: new Date(d.createdAt)
                  }
              )
          )
          .forEach(d => Object.assign(dataObject, { [d.id]: d }));
      Vue.set(state, "data", dataObject);
    };
    module.actions.insert = ({state}, newChangeEvent) => {
      let changeEventId = uniqid();
      newChangeEvent = {...newChangeEvent, id: changeEventId};
      Vue.set(state.data, changeEventId, newChangeEvent);
      return changeEventId;
    }
  },

  /** Voting Module */
  votingModuleDecorator: (module: any): void => {
    /**
   * ends the voting of the section because ite reached threshold
   * sending notifications
   * navigation to success page
   * @param {VotesInterface} updatedVotes
   * @param {SectionInterface} section
   * @param {string} parentSectionId
   * @param {number} sectionIndex
   */
    module.actions.endVoting = async ({ dispatch, commit, rootGetters }, { section, parentSectionId, sectionIndex }) => {
      commit('displayModule/showSnackbar', {}, {root: true})
    }
  },

  displayModuleDecorator: (module: any): void => {},

  routerModuleDecorator: (module: any): void => {}
}

